import { createRouter, createWebHashHistory } from 'vue-router'
import store from '@/store'
import { pcRoutes, h5Routes } from './routes'

let routes = []

if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
  routes = [...h5Routes]
} else {
  routes = [...pcRoutes]
}

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.beforeEach(async (to, from, next) => {
  await store.dispatch('user/setUserInfo')
  next()
})

export default router
